import { combineReducers } from '@reduxjs/toolkit';

import teamTasksSlice from './teamTasks/teamTasksSlice';
import allTasksSlice from './allTasks/allTasksSlice';
import myTasksSlice from './myTasks/myTasksSlice';

export default combineReducers({
  teamTasks: teamTasksSlice,
  allTasks: allTasksSlice,
  myTasks: myTasksSlice,
});
